import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useProgram = (id: number) =>
  useQuery({
    // Under "programs" so create/edit/delete invalidate it. "detail" keeps it apart from the
    // differently shaped ["programs", id] entry ProgramEdit.jsx caches through useFetch.
    queryKey: ["programs", "detail", id],
    queryFn: async () => await apiClient.getProgram({ params: { id } }),
    staleTime: Infinity,
  });
